export default "__VITE_ASSET__J_SHMoLm__"